import { API_REQUEST, API_SUCCESS, API_RESPONSE_FAILURE,API_FETCH_ERROR } from "./apiActions";

const initialState = {
  requests: {}, // { [key]: { loading, success, error, message } }
};

const apiReducer = (state = initialState, action) => {
  const key = action.payload?.key || "default";

  switch (action.type) {
    case API_REQUEST: {
      // Reset all keys with success: true to false when a new request comes in
      const updated = { ...state.requests };
      Object.keys(updated).forEach(requestKey => {
        if (updated[requestKey]?.success) {
          updated[requestKey] = {
            ...updated[requestKey],
            success: false,
          };
        }
      });
      
      // Set the current request key to loading state
      updated[key] = {
        loading: true,
        success: false,
        error: null,
        message: "",
      };
      
      return {
        ...state,
        requests: updated,
      };
    }

    case API_SUCCESS: {
      // keep request entry and update its status + message from payload
      const updated = { ...state.requests };
      const current = updated[key] || {};
      updated[key] = {
        ...current,
        loading: false,
        success: true,
        error: null,
        message: action.payload?.message || current.message || "",
      };
      return {
        ...state,
        requests: updated,
      };
    }

    case API_RESPONSE_FAILURE: {
      // keep request entry and set failure info + message from payload
      const updated = { ...state.requests };
      
      // Reset all request keys to default if they were in loading state
      Object.keys(updated).forEach(requestKey => {
        if (updated[requestKey]?.loading) {
          updated[requestKey] = {
            loading: false,
            success: false,
            error: null,
            message: "",
          };
        }
      });
      
      // Set failure info for the specific key
      const current = updated[key] || {};
      updated[key] = {
        ...current,
        loading: false,
        success: false,
        error: action.payload?.error ?? true,
        message: action.payload?.message || current.message || "",
      };
      return {
        ...state,
        requests: updated,
      };
    }
    case API_FETCH_ERROR: {
      // keep request entry and set failure info + message from payload
      const updated = { ...state.requests };
      const current = updated[key] || {};
      updated[key] = {
        ...current,
        loading: false,
        success: false,
        error: action.payload?.message ?? true,
        message: action.payload?.message || current.message || "",
      };
      return {
        ...state,
        requests: updated,
      };
    }

    case 'RESET_API_STATE':
      return initialState;
      
    

    default:
      return state;
  }
};

export default apiReducer;
